import VideoInfoModalSidebar from './VideoInfoModalSidebar';

export default VideoInfoModalSidebar;
